import { useAppDispatch } from '@/state/hooks';
import useScreenSizes from '@/utils/hooks/useScreenSizes';
import useLayout, { XplorSpotModules } from '@/utils/hooks/useXplorSpotLayout';

import { roundedFullClassname } from '@/helpers/environmentHelper';
import { setXplorSpotMobileLayoutNode } from '@/state/reducers/xplorSpotLayoutSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import cn from 'classnames';
import { useMemo } from 'react';
import { IconType } from 'react-icons/lib';
import {
    MdAccountBalanceWallet,
    MdCandlestickChart,
    MdHistory,
    MdPriceChange,
    MdSwapVerticalCircle
} from 'react-icons/md';
import { updateTree } from 'react-mosaic-component';

const TabletTabNavigation = () => {
    const dispatch = useAppDispatch();

    const lang = useLanguage();
    const screen = useScreenSizes();
    const { layout } = useLayout(screen);

    const tabs: {
        label: string;
        name: XplorSpotModules;
        title: string;
        Icon: IconType;
    }[] = useMemo(() => {
        return [
            {
                label: 'Order',
                name: 'Order',
                title: lang.locale !== 'en' ? lang.modules.order : 'Order',
                Icon: MdSwapVerticalCircle
            },
            {
                label: 'Prices',
                name: 'Order Book',
                title: lang.locale !== 'en' ? lang.modules['order-book'] : 'Market Depth',
                Icon: MdPriceChange
            },
            {
                label: 'Chart',
                name: 'Chart',
                title: lang.locale !== 'en' ? lang.modules.chart : 'Chart',
                Icon: MdCandlestickChart
            },
            {
                label: 'Blotters',
                name: 'Blotter',
                title: lang.locale !== 'en' ? lang.modules.blotter : 'Blotter',
                Icon: MdHistory
            },
            {
                label: 'Balances',
                name: 'Balances',
                title: lang.locale !== 'en' ? lang.modules.balances : 'Balances',
                Icon: MdAccountBalanceWallet
            }
        ];
    }, [lang]);

    return (
        <div className="flex items-center justify-between w-full">
            <div className="flex gap-0.5">
                {tabs.map(({ name, title, Icon }) => (
                    <div
                        key={name}
                        className={cn(
                            'flex uppercase cursor-pointer text-brand-text font-semibold px-2 gap-2 items-center',
                            {
                                ['bg-brand-accent text-brand-module-title']: name === layout?.first,
                                ['bg-brand-neutral-800 hover:bg-brand-neutral-700']: name !== layout?.first
                            },
                            roundedFullClassname
                        )}
                        onClick={() => switchTab(layout, name, dispatch)}>
                        <Icon className="w-3.5 h-3.5" />
                        {title}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TabletTabNavigation;

const switchTab = (mobileLayoutNode, moduleToDrop, dispatch) => {
    let currentNode = mobileLayoutNode;
    if (currentNode) {
        currentNode = updateTree(currentNode, [
            {
                path: [],
                spec: {
                    $set: {
                        direction: 'row',
                        first: moduleToDrop,
                        second: '',
                        splitPercentage: 100
                    }
                }
            }
        ]);
    } else {
        currentNode = moduleToDrop;
    }
    dispatch(setXplorSpotMobileLayoutNode(currentNode));
};
